import * as _AdmissionRules from './admissions';
export { _AdmissionRules as AdmissionRules };
import * as _MedicalAidRules from './medicalAid';
export { _MedicalAidRules as MedicalAidRules };
//# sourceMappingURL=index.js.map